import { render, staticRenderFns } from "./iconStar.vue?vue&type=template&id=3c12e335"
import script from "./iconStar.vue?vue&type=script&lang=js"
export * from "./iconStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports